module.exports = __webpack_public_path__ + "img/epr-price@2x.a265ac44.jpeg";